import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CellRenderService {
  constructor() {}

  /**
   * Retrieves the appropriate cell renderer function based on column configuration.
   * @param params - Parameters provided by AgGrid for rendering, including cell data.
   * @param column - Column configuration object, which may specify a cellRenderer key.
   * @returns The HTML content generated by the renderer function, or undefined if no renderer is specified.
   */
  getCellRenderer(params: any, column: Record<string, any>): any {
    if (column.cellRenderer === 'hyperlinkRenderer') {
      return this.hyperlinkRenderer(params);
    }
  }

  /**
   * Renders a cell value as a clickable hyperlink that opens in a new tab.
   * @param params - Parameters provided by ag-Grid, including the cell's value.
   * @returns HTML string with an anchor tag linking to the cell value as a URL.
   */
  hyperlinkRenderer(params: any): string {
    const cellValue = params?.value;
    return cellValue
      ? `<a href="${cellValue}" target="_blank" style="color: blue;">${cellValue}</a>`
      : '';
  }
}
